import { Button, message, Modal, Upload, Select, Form, Dropdown, Menu, Space } from 'antd';
import React from 'react';
import { api, use } from 'xadmin';
import { Icon } from 'xadmin-ui';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import _ from 'lodash'

const { Option } = Select;

function s2ab(s/*:string*/)/*:ArrayBuffer*/ {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
  return buf
}

const UploadComponent = ({ title }) => {
  const { canAdd } = use('model.permission')
  const { modelDispatch } = use('model')
  const { addExporImportLog } = use('log.exporImport')

  const [visible, setVisible] = React.useState(false)
  const [notSkip, setNotSkip] = React.useState('false')

  const showModal = () => {
    setVisible(true)
  };

  const handleOk = e => {
    setVisible(false)
  };

  const handleCancel = e => {
    setVisible(false)
  };

  const props = {
    name: 'file',
    accept: '.xlsx',
    maxCount: 1,
    showUploadList: false,
    action: api({ name: 'media' }).getHost() + `core/systemVariable/import/excel/${notSkip}`,
    headers: {
      Authorization: api({ name: 'media' }).headers.Authorization,
      ..._.omit(api({ name: 'media' }).getHeaders(), 'Content-Type')
    },
    onChange(info) {
      if (info.file.status === 'done') {
        const res = info.fileList[0] && info.fileList[0].response
        if (res && res.failCount > 0 || res && res.failList.length > 0) {
          const failInfo = res.failList.map(i => i.name + `(${i.uid})、`)
          const importStatus = res.failList[0] && res.failList[0].importStatus
          message.error(info.file.name + ' 文件中, ' + failInfo + importStatus);
        } else if (res && res.failCount == 0) {
          message.success(info.file.name + '数据导入成功！');
          modelDispatch({ type: 'GET_ITEMS' })
        }
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 数据导入失败！`);
      }
    }
  }

  const jsonProps = {
    name: 'file',
    accept: '.json',
    showUploadList: false,
    headers: _.omit(api({ name: 'media' }).getHeaders(), 'Content-Type'),
    beforeUpload: (file) => {
      const reader = new FileReader()

      reader.onload = (e) => {
        const data = e.target.result
        let vars = null
        try {
          vars = JSON.parse(data)
        } catch {
          message.error('导入失败！JSON文件格式错误');
          return
        }
        if (!_.isArray(vars)) {
          message.error('导入失败！JSON文件中必须是一个数组');
          return
        }
        vars = vars.map(v => {
          const vv = {
            name: v.name || v['名称'],
            uid: v.uid || v['编号'],
            value: v.value || v['值'],
            type: v.type || v['类型'] || 'string'
          }
          if (vv.value == undefined) {
            return null
          }
          if (_.isNumber(vv.value)) {
            vv.type = 'number'
          } else if (_.isBoolean(vv.value)) {
            vv.type = 'boolean'
          } else if (_.isPlainObject(vv.value)) {
            vv.type = 'object'
          } else if (_.isArray(vv.value)) {
            vv.type = 'array'
          }
          return vv
        }).filter(Boolean)

        const uids = vars.map(v => v.uid)
        const varApi = api({ name: 'core/systemVariable' })

        varApi.query({}, {
          where: {
            uid: { $in: uids }
          }
        }).then(({ items }) => {
          Promise.all(vars.map(v => varApi.save({
            ...(_.find(items, i => i.uid == v.uid) || {}),
            ...v
          })))
            .then(() => {
              message.success('导入成功')
              addExporImportLog && addExporImportLog({
                mode: 'import',
                info: '导入数据字典', data: items,
                schema: { title: '数据字典' },
              })
              modelDispatch({ type: 'GET_ITEMS' })
            })
            .catch((e) => {
              message.error('导入失败！' + (Object.values(e.json).join(', ') || e.message))
            })
        })
      }

      reader.readAsText(file)
      return false
    }
  }

  const onDownloadExcel = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      [
        { v: '名称', t: 's' },
        { v: '编号', t: 's' },
        { v: '类型（number string）', t: 's' },
        { v: '值', t: 's' }
      ],
      [
        { v: '测试', t: 's' },
        { v: 'TEST', t: 's' },
        { v: 'string）', t: 's' },
        { v: 'Hello', t: 's' }
      ],
    ])
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws)
    /* generate XLSX file */
    const wbout = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' })
    /* send to client */
    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), '数据字典_导入模板.xlsx')
  }

  const handleJSONClick = () => {
    api({ name: 'core/systemVariable' }).query({ fields: ['name', 'uid', 'type', 'value'] })
      .then(({ items }) => {
        saveAs(new Blob([JSON.stringify(items.map(i => ({
          name: i.name, uid: i.uid, type: i.type, value: i.value
        })), 0, 2)], { type: 'application/json;charset=utf-8' }), '数据字典.json')
        addExporImportLog && addExporImportLog({
          mode: 'export',
          info: '导出数据字典', data: items,
          schema: { title: '数据字典' },
        })

      })
      .catch(e => message.error('导出失败！'))
  }

  return canAdd && (
    <span>
      <Dropdown.Button type="primary" onClick={showModal} overlay={(
        <Menu>
          <Menu.Item key="1" onClick={handleJSONClick}>
            JSON文件导出
          </Menu.Item>
          <Menu.Item key="2">
            <Upload {...jsonProps} >
              JSON文件导入
            </Upload>
          </Menu.Item>
        </Menu>
      )}>
        {title}
      </Dropdown.Button>
      <Modal
        title={title}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
      >
        <Form.Item label="数据模板" extra="请根据模板填写数据">
          <Button onClick={onDownloadExcel} >下载模板</Button>
        </Form.Item>
        <Form.Item label="校验方式" extra="数据字典项目重复时如何处理">
          <Select style={{ width: '80%' }} value={notSkip} defaultValue={'false'} placeholder="上传校验方式" onChange={(v) => setNotSkip(v)}>
            <Option value="false">报错提示并跳转</Option>
            <Option value="true">覆盖更新</Option>
          </Select>
        </Form.Item>
        <Form.Item label="上传文件">
          <Upload {...props} >
            <Button type="primary"><Icon type="upload" />上传 </Button>
          </Upload>
        </Form.Item>
      </Modal>
    </span>
  )
}

export default UploadComponent
